// polyhavenService.js

// 辅助函数：检测图片 URL 是否有效
async function checkImageExists(url) {
  try {
    const res = await fetch(url, { method: 'HEAD' });
    return res.ok;
  } catch {
    return false;
  }
}

export async function fetchFreePanorama(prompt = '') {
  const searchTerm = prompt.trim();
  if (!searchTerm) {
    return "https://threejs.org/examples/textures/2294472375_24a3b8ef46_o.jpg";
  }

  // 1. 中英文翻译支持
  const translateToEnglish = async (text) => {
    if (!/[\u4e00-\u9fa5]/.test(text)) return text;
    try {
      const res = await fetch(`https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=zh|en`);
      const data = await res.json();
      return data.responseData?.translatedText || text;
    } catch {
      return text;
    }
  };

  // 2. Wikimedia 智能检索
  const queryWiki360 = async (searchQuery) => {
    const url = `https://commons.wikimedia.org/w/api.php?action=query&generator=search&gsrsearch=${encodeURIComponent(searchQuery)}&gsrnamespace=6&prop=imageinfo&iiprop=url|mime|size&iiurlwidth=2048&format=json&origin=*`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      const pages = data.query?.pages;
      if (pages) {
        const blacklist = ['mars', 'curiosity', 'perseverance', 'rover', 'lander', 'moon', 'lunar', 'spacecraft', 'map', 'plan', 'chart', 'svg', 'portrait'];
        for (const key of Object.keys(pages)) {
          const info = pages[key]?.imageinfo?.[0];
          const imgUrl = info?.thumburl || info?.url;
          const mime = info?.mime;
          const width = info?.width || 0;
          const height = info?.height || 1;
          const aspectRatio = width / height;
          const title = (pages[key]?.title || '').toLowerCase();

          const isBlacklisted = blacklist.some(word => title.includes(word));
          if (imgUrl && !isBlacklisted && (mime === "image/jpeg" || mime === "image/png")) {
            if (aspectRatio >= 1.9) {
              return imgUrl.replace(/&amp;/g, '&');
            }
          }
        }
      }
    } catch (e) {
      console.warn("Wikimedia 查询失败:", searchQuery, e);
    }
    return null;
  };

  try {
    const englishTerm = (await translateToEnglish(searchTerm)).toLowerCase();

    // 【第一级】Poly Haven 真实 API 解析 (通过 API 动态获取真实文件 URL)
    try {
      const polyRes = await fetch('https://api.polyhaven.com/assets?t=hdris');
      const polyData = await polyRes.json();
      
      const matchedKey = Object.keys(polyData).find(key => {
        const tags = polyData[key]?.tags || [];
        const name = key.toLowerCase();
        const categories = polyData[key]?.categories || [];
        const regex = new RegExp(`\\b${englishTerm}\\b`, 'i');
        return regex.test(name) || tags.some(t => regex.test(t)) || categories.some(c => regex.test(c));
      });

      if (matchedKey) {
        // 请求 Poly Haven 官方的 Files API 获取正确的下载节点
        const fileRes = await fetch(`https://api.polyhaven.com/files/${matchedKey}`);
        const fileData = await fileRes.json();
        
        // 优先提取 2k JPG/PNG 预览或高清全景图地址
        const hdriFiles = fileData?.hdri;
        if (hdriFiles) {
          const resKey = hdriFiles['2k'] ? '2k' : (hdriFiles['4k'] ? '4k' : Object.keys(hdriFiles)[0]);
          const targetUrl = hdriFiles[resKey]?.jpg?.url || hdriFiles[resKey]?.png?.url;
          if (targetUrl) {
            return targetUrl;
          }
        }
      }
    } catch (e) {
      console.warn("Poly Haven 动态解析跳过:", e);
    }

    // 【第二级】Wikimedia 智能检索
    let wikiUrl = await queryWiki360(`${englishTerm} 360 equirectangular panorama`);
    if (wikiUrl) return wikiUrl;

    wikiUrl = await queryWiki360(`${englishTerm} 360 degree panorama`);
    if (wikiUrl) return wikiUrl;

    wikiUrl = await queryWiki360(`${englishTerm} spherical panorama`);
    if (wikiUrl) return wikiUrl;

    // 【第三级】AI 全景图兜底生成
    const seed = Math.floor(Math.random() * 100000);
    const genericPanoPrompt = encodeURIComponent(`360 panorama of ${englishTerm}, equirectangular, 8k photo`);
    return `https://image.pollinations.ai/prompt/${genericPanoPrompt}?width=1024&height=512&nologo=true&seed=${seed}`;

  } catch (error) {
    console.warn("全景图混合检索异常:", error);
  }

  return "https://threejs.org/examples/textures/2294472375_24a3b8ef46_o.jpg";
}